<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="132"></ucMenu>
          <div class="right_con">
            <div class="rc_main">

              <div style="display: flex;align-items: center;justify-content: space-between;">
                <p class="fb">云商品库 - {{dataInfo.batch_no}}</p>
                <el-button type="primary" size="small" @click="handleBack">返回</el-button>
              </div>
              <div style="margin-top: 14px">
                <el-form inline size="small">
                  <el-form-item label="状态">
                    <el-select v-model="searchParams.status" clearable placeholder="全部" @change="handleSearch">
                      <el-option v-for="item in statusList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <el-table v-loading="loading" :data="tableData"
                        :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table"
                        highlight-current-row row-key="id">
                <el-table-column label="序号" align="center" prop="row_index" width="80"></el-table-column>
                <el-table-column label="商品信息" >
                  <template #default="{ row }">
                    <div class="goods-box">
                      <img :src="row.main_image" class="goods-img">
                      <div class="goods-info">
                        <div>{{row.title}}</div>
                        <div>价格：{{row.price}}</div>
                        <div>来源平台ID：{{row.source_product_id}}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="状态" prop="status" align="center" width="80">
                  <template #default="{ row }">
                    <el-tag :type="statusTag[row.status]" size="small">{{row.status_text}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="错误信息" prop="error_msg" align="center"></el-table-column>
              </el-table>

              <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getDataList" v-if="page_data.total>page_data.limit" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>


  </div>
</template>
<script>
import {mapActions} from "vuex";

import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import Pagination from "@/components/pagination/pagination.vue";

export default {
  name: 'ucenterProductDetails',
  components: {
    Pagination,
    ucMenu,
    myHead,
    myFoot
  },
  data() {
    return {
      dataInfo:{},
      loading: false,
      tableData: [],
      page_data: {
        limit: 10,
        page: 1,
        total:0,
      },
      searchParams:{},
      batchId:'',
      statusList:[{label:'待处理',value:0},{label:'成功',value:1},{label:'失败',value:2},{label:'重复跳过',value:3}],
      statusTag:['primary','success','danger','info'],
    }
  },
  created() {
    this.batchId = this.$route.query.id
    this.getDetails()
    this.getDataList()
  },

  methods: {
    ...mapActions({
      getImportDetail: 'ucenter/getImportDetail',
      getImportItems: 'ucenter/getImportItems',
    }),
    handleBack(){
      this.$router.back()
    },
    //获取盲盒列表
    getDataList() {
      this.loading = true
      let param = {page_size:this.page_data.limit,page:this.page_data.page,batch_id:this.batchId,...this.searchParams}
      this.getImportItems({
        data: param,
        success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.page_data.total = res.data.total
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },
    getDetails(){
      this.getImportDetail({
        data: {batch_id :this.batchId},
        success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.dataInfo  = res.data
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },
    handleSearch(){
      this.page_data.page = 1
      this.getDataList()
    },

  }
}
</script>


<style scoped>

.center {
  display: flex;
  flex: 1;
}

.ucenter_main {

  min-height: 500px;
}

.rc_table {
  width: 100%;
 /* margin-top: 20px;*/
}

.rc_main {
  padding: 36px 40px 46px;
}
.goods-box{
  display: flex;
  line-height: 16px;
  font-size: 14px;
}
.goods-img{
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin-right: 5px;
}
.goods-info{
  flex: 1;
}
.goods-info div~div{
  margin-top: 4px;
}
</style>
